<template>
    <div class="package-banner-card card border-0 h-100" :style="{'background-image': 'linear-gradient(50deg, '+themeClrFrom+','+themeClrTo+')'}"
         :class="{'banner-upsell--top': position === 'top', 'banner-upsell--bottom': position === 'bottom'}">
        <div class="card-body d-flex flex-column justify-content-between text-center p-3">
            <div>
                <div class="text-uppercase font-weight-bold text-white-50" style="font-size: 0.8em"> {{ $t('pages.checkins_detail.package_banner_pretitle') }} </div>
                <div class="font-weight-bolder pt-1 h4"> {{ title }} </div>
                <div class="text-white-50 pb-2"> {{ subtitle }} </div>
            </div>

            <div class="pb-3" v-if="discount">
                <div class="badge badge-dark badge-lg">
                    {{ discount  }}
                </div>
            </div>

            <div class="pb-2 h4 font-weight-normal" v-if="priceOriginal !== price">
                <del class="text-white-50"> {{ priceOriginal }} </del>
            </div>

            <div class="align-self-center w-100">
                <button-with-spinner
                        class="btn btn-primary btn-xs-block btn-sm-block btn-md-block" :class="{'btn-block px-2': btnFullWitdhOnDesktop}"
                        :disabled="isAlreadyAdded" @click="emitClickEvent" :loading="showSpinner">
                    <span v-if="isAlreadyAdded">
                        {{ $t('pages.checkins_detail.package_banner_btn_added') }}
                    </span>
                    <span v-else>
                        <span :class="{'d-lg-inline d-none': price}">{{ price ? $t('pages.checkins_detail.package_banner_btn_buy_now') : $t('pages.checkins_detail.package_banner_btn_add') }}</span> {{ price }}
                    </span>
                    <!--
                    <img src="@/assets/icon-add-blue.svg" height="20">
                    <template v-if="eventClosed">{{ $t('pages.checkins_detail.package_banner_btn_buy_now') }}</template>
                    <template v-else>{{ $t('pages.checkins_detail.package_banner_btn_prepurchase_now') }}</template>
                    -->
                </button-with-spinner>
            </div>
        </div>
    </div>
</template>


<script>
import ButtonWithSpinner from '@/components/ButtonWithSpinner'

export default {
    components: { ButtonWithSpinner },
    props: {
        title: {type: String},
        subtitle: {type: String},
        discount: {type: String, required: false},
        eventClosed: {type: Boolean},
        price: {type: String},
        priceOriginal: {type: String},
        position: {type: String},
        isAlreadyAdded: {type: Boolean, default: false},
        themeClrFrom: {type: String, default: '#474684'},
        themeClrTo: {type: String, default: '#1A192E'},
        btnFullWitdhOnDesktop: {type: Boolean, default: true},
    },
    data() {
        return {
            showSpinner: false
        }
    },
    methods: {
        emitClickEvent() {
            this.showSpinner = true
            this.$emit('clicked-buy-now')
            // we fake spinner disable, actually not needed as we should move to the checkout
            setTimeout(() => this.showSpinner = false, 1000)
        }
    }
}
</script>
